var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49967 6.00001V1.33334H12.4997V6.00001M4.49967 12H3.16634C2.81272 12 2.47358 11.8595 2.22353 11.6095C1.97348 11.3594 1.83301 11.0203 1.83301 10.6667V7.33334C1.83301 6.97972 1.97348 6.64058 2.22353 6.39053C2.47358 6.14049 2.81272 6.00001 3.16634 6.00001H13.833C14.1866 6.00001 14.5258 6.14049 14.7758 6.39053C15.0259 6.64058 15.1663 6.97972 15.1663 7.33334V10.6667C15.1663 11.0203 15.0259 11.3594 14.7758 11.6095C14.5258 11.8595 14.1866 12 13.833 12H12.4997M4.49967 9.33334H12.4997V14.6667H4.49967V9.33334Z",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.211eacbcdd67de8516b232318e9607c7.svg";
export { ForwardRef as ReactComponent };